import { environment } from '@rpgc-ai/environments';

import { createAuthClient } from 'better-auth/client';
import { twoFactorClient } from 'better-auth/plugins';

/**
 * Конфигурация клиента аутентификации
 */
export const AUTH_CONFIG = {
  baseURL: environment.API_URL,
  cookies: {
    name: 'cortex_session_token',
    secure: true,
    sameSite: 'lax' as const,
    domain: `.${environment.APP_DOMAIN}`,
    path: '/',
  },
};

export const yandexAuth = {
  signIn: {
    yandex: async (options: { callbackURL: string; providerId: string }): Promise<{ redirect: boolean; url: string }> => {
      const response = await fetch(`${AUTH_CONFIG.baseURL}/api/auth/sign-in/oauth2`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(options),
      });

      if (!response.ok) {
        throw new Error(`Yandex auth request failed: ${response.statusText}`);
      }

      const data = await response.json();
      return data; // Возвращаем оригинальный ответ с бэкенда
    },
  },
};

/**
 * Клиент Better-Auth для взаимодействия с сервером авторизации
 */
export const authClient = createAuthClient({
  baseURL: AUTH_CONFIG.baseURL,
  cookies: AUTH_CONFIG.cookies,
  plugins: [twoFactorClient()],
});

/**
 * Клиент Better-Auth расширенный с Yandex
 */
export const authClientYandex = {
  signIn: {
    yandex: yandexAuth.signIn.yandex,
  },
};

/**
 * Преобразует заголовки из формата Node.js в формат для fetch
 * @param headers - HTTP заголовки запроса
 * @returns Объект заголовков для fetch
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function normalizeHeaders(headers: any): Record<string, string> {
  const normalized: Record<string, string> = {};

  if (!headers) {
    return normalized;
  }

  // Проверяем, есть ли метод forEach (у Headers объекта)
  if (typeof headers.forEach === 'function') {
    headers.forEach((value: string, key: string) => {
      normalized[key] = value;
    });
    return normalized;
  }

  // Обрабатываем как обычный объект
  for (const [key, value] of Object.entries(headers)) {
    if (value !== undefined) {
      normalized[key] = Array.isArray(value) ? value.join(', ') : typeof value === 'string' ? value : String(value);
    }
  }

  return normalized;
}
